import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withFirebase } from "../../components/Firebase/Firebase";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import Loading from "../../components/Loading/Loading";
import Stage1 from "./Stage1";
import Stage2 from "./Stage2";
import Stage3 from "./Stage3";
import Stage4 from "./Stage4";
import Stage5 from "./Stage5";
import Stage6 from "./Stage6";
import Stage7 from "./Stage7";
import ErrorPage from "../ErrorPage/ErrorPage";

class CompetitionEnter extends Component {
  state = {
    stage: 1,
    competitionId: null,
    error: false
  };

  async componentDidMount() {
    try {
      if (this.props.entryId) {
        // If we already have an entry, lets fetch it
        this.props.methods.subscribeToEntry(this.props.entryId);
      }
      // Get competition data by slug
      const competitionId = await this.props.methods.getCompetitionBySlug(
        this.props.slug
      );
      this.setState({ competitionId });
    } catch (error) {
      this.setState({
        error: true
      });
    }
  }

  componentWillUnmount() {
    if (this.props.entryId) {
      this.props.methods.unsubscribeFromEntry(this.props.entryId);
    }
  }

  render() {
    // Invalid competition slug
    if (this.state.error) {
      return <ErrorPage />;
    }
    // Competition is not open
    const invalidCompetitionState =
      this.state.competitionId &&
      this.props.competitions[this.state.competitionId].state !== "open";

    if (invalidCompetitionState) {
      return <ErrorPage />;
    }

    let stageComponent;
    // console.log('slug', this.props.slug, this.props.entryId, this.state.competitionId)
    
    if (!this.state.competitionId) {
      // If we're still fetching the competitionId
      stageComponent = <Loading />;
    } else if (!this.props.entryId) {
      stageComponent = (
        <Stage2
          competitionId={this.state.competitionId}
          slug={this.props.slug}
        />
      );
    } else {
      // Get the current stage from Firebase
      const entryData = this.props.entries[this.props.entryId];
      if (!entryData) {
        // If we have an ID but not entry data, show a loading spinner while it is being fetched
        stageComponent = <Loading />;
      } else {
        // Show the appropriate stage
        switch (entryData.stage) {
          case 1:
            stageComponent = (
              <Stage3
                id={this.props.entryId}
                competitionId={this.state.competitionId}
                slug={this.props.slug}
              />
            );
            break;
          case 2:
            stageComponent = (
              <Stage2
                id={this.props.entryId}
                competitionId={this.state.competitionId}
                slug={this.props.slug}
              />
            );
            break;
          case 3:
            stageComponent = (
              <Stage3
                id={this.props.entryId}
                competitionId={this.state.competitionId}
                slug={this.props.slug}
              />
            );
            break;
          case 4:
            stageComponent = (
              <Stage4
                id={this.props.entryId}
                competitionId={this.state.competitionId}
                slug={this.props.slug}
              />
            );
            break;
          case 5:
            stageComponent = (
              <Stage5
                id={this.props.entryId}
                competitionId={this.state.competitionId}
                slug={this.props.slug}
              />
            );
            break;
          case 6:
            stageComponent = (
              <Stage6
                id={this.props.entryId}
                competitionId={this.state.competitionId}
                slug={this.props.slug}
              />
            );
            break;
          case 7:
            stageComponent = (
              <Stage7
                id={this.props.entryId}
                competitionId={this.state.competitionId}
                slug={this.props.slug}
              />
            );
            break;
          default:
            stageComponent = null;
            break;
        }
      }
    }
    return (
      <PageWrapper anonymousAuth context="competition-entry">
        {this.state.competitionId && (
          <Helmet
            title={`Videos for Change | Enter Competition - ${
              this.props.competitions[this.state.competitionId].name
            }`}
          />
        )}
        {stageComponent}
      </PageWrapper>
    );
  }
}

export default withFirebase(CompetitionEnter);



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/CompetitionEnter.js